module.exports = __webpack_public_path__ + "static/eating-better.a5e5c652.jpg";